define('views/content/distributor_roles',['require','views/base/list_page_view','views/components/distributor_role/distributor_roles','collections/distributor_roles','text!templates/content/distributor_roles.html'],function(request){

    var BaseListPageView = require('views/base/list_page_view');

    var RoleView = require('views/components/distributor_role/distributor_roles');
    var DistributorRolesCollection = require('collections/distributor_roles');

    var temp = require("text!templates/content/distributor_roles.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'distributor-roles-page',
        titleKey: 'personal_roles',

        setCollection: function () {
            this.collection = new DistributorRolesCollection();
        },

        onRender: function() {
            this.ListContainer.show(new RoleView({
                collection: this.collection
            }));
        }

    });
});
